<script setup lang="ts">
import { onMounted, onUnmounted } from "vue";
import { App, type AppState } from "@capacitor/app";

import useChatStore from "@/Modules/Chat/Store";
import useAuthStore from "@/Modules/Auth/Store";
import useUserStore from "@/Modules/User/Store";
import usePrivacyStore from "@/Modules/Privacy/Store";
import useVideoCallStore from "@/Modules/VideoCall/Store";

import { isValidString } from "@/Utils/String";
import { isApp } from "@/Utils/Ionic";
import { log } from "@/Utils/Debug";
import { hasValue } from "@/Utils/Objects";

const chatStore = useChatStore();
const authStore = useAuthStore();
const privacyStore = usePrivacyStore();
const userStore = useUserStore();
const videoCallStore = useVideoCallStore();

const onlineListener = () => {
  chatStore.reconnect();
  videoCallStore.checkVideoCallInProgress();
};

const appStateChange = async ({ isActive }: AppState) => {
  if (!isActive) {
    log("Closing ws");
    chatStore.closeWebSocket();
  } else if (hasValue(userStore.user) && isValidString(authStore.userToken)) {
    if (!privacyStore.needProtection()) {
      log("Reconnect ws");

      onlineListener();
    }
  }
};

onMounted(() => {
  window.addEventListener("online", onlineListener);

  if (isApp()) {
    App.addListener("appStateChange", appStateChange);
  }
});

onUnmounted(() => {
  window.removeEventListener("online", onlineListener);

  if (isApp()) {
    App.removeAllListeners();
  }
});
</script>

<template>
  <slot />
</template>

<style lang="scss"></style>
